import { graphql } from "@opensea/graphql"

export const CurrencyStatsFragment = graphql(`
  fragment CurrencyStats on Currency {
    symbol
    chain {
      name
    }
    stats {
      marketCapUsd
      fdvUsd
      totalSupply
      oneDay {
        volume
        priceChange
        marketCapChange
      }
    }
  }
`)
